import React from 'react';
import { Link } from 'react-router-dom';

export const JavascriptWarning: React.FC = () => {
  return <noscript>
    <div className="jsWarning" style={{ display: "none" }}>
      <div>
        <h2>This section of the site requires Javascript.</h2>
        <p>Please enable it to continue</p>
        <Link to="/">Return to Home</Link>
      </div>
    </div>
  </noscript>
};